<template>
  <v-card class="pb-4 card-video" outlined>
    <div class="card-video-player">
      <video controls>
        <source :src="url" type="video/mp4" />
        Seu navegador não suporta vídeo HTML5.
      </video>

      <!-- <div class="card-video-player-mask">
        <v-btn
          class="card-video-player-button"
          aria-label="Play/Pause"
          height="40px"
          width="40px"
          icon
        >
          <v-icon class="card-video-player-button-icon" size="40px">
            {{ isPlaying ? "mdi-pause" : "mdi-play" }}
          </v-icon>
        </v-btn>
      </div> -->
    </div>

    <div class="black--text text-body-1 font-weight-medium mt-3 mx-3">
      {{ name }}
    </div>
  </v-card>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    id: Number,
    url: String,
    name: String,
    previewTime: {
      type: Number,
      default: 2,
    },
  },
  data: () => ({
    isPlaying: false,
  }),
};
</script>

<style lang="scss" scoped>
$transition: all 0.2s ease;

.card-video {
  border-radius: 12px !important;
  overflow: hidden;

  &-player {
    aspect-ratio: 16 / 9;
    border-radius: 12px 12px 0 0 !important;
    cursor: pointer;
    overflow: hidden;
    max-width: 800px;
    position: relative;
    width: 100%;

    video {
      border-radius: 12px 12px 0 0 !important;
      background-color: #000000;
      display: block;
      height: 102%;
      object-fit: cover;
      width: 100%;

      // &::-webkit-media-controls {
      //   opacity: 0;
      //   pointer-events: none;
      //   transition: $transition;
      // }
    }

    //   &-mask {
    //     align-items: center;
    //     background-color: rgba(0, 0, 0, 0.3);
    //     display: flex;
    //     height: 100%;
    //     justify-content: center;
    //     left: 0;
    //     pointer-events: none;
    //     position: absolute;
    //     top: 0;
    //     transition: $transition;
    //     width: 100%;
    //   }

    //   &-button {
    //     transition: $transition;

    //     &-icon {
    //       color: rgba(255, 255, 255, 0.3) !important;
    //       transition: $transition;
    //     }
    //   }

    //   &.playing {
    //     video::-webkit-media-controls {
    //       opacity: 1;
    //     }

    //     .card-video-player-mask {
    //       opacity: 0;
    //     }
    //   }
    // }

    // &:hover {
    //   .card-video-player-mask {
    //     background-color: transparent;
    //   }

    //   .card-video-player-button {
    //     transform: scale(1.2);

    //     &-icon {
    //       color: rgba(255, 255, 255, 1) !important;
    //       text-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    //     }
    //   }
  }
}
</style>
